<template>
  <div id="mShop">
    <Nav type="transparent" />
    <span class="pageTitle">精品店信息</span>
    <div style="height: 1px;"></div>
    <div class="blockTit">中关村大融城店</div>
    <img src="../assets/shop-photo11.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map17"></div>
      <i @click="showInfo('map18')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 海淀区 大融城东区地下2层
        <br />
        X-LG2-11+12
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:15210105714">15210105714</a>
    </div>

    <div class="blockTit">凤凰汇甄选店</div>
    <img src="../assets/shop-photo5.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map9"></div>
      <i @click="showInfo('map10')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 朝阳区 左家庄街道 凤凰汇购物中心
        <br />
        2层L217
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:13521804086">13521804086</a>
    </div>

    <div class="blockTit">太古里旗舰店</div>
    <img src="../assets/shop-photo12.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map1"></div>
      <i @click="showInfo('map4')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 朝阳区 大三里屯太古里南区
        <br />
        B1-SLG21b
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:18614090335">18614090335</a>
    </div>

    <div class="blockTit">阜成门店</div>
    <img src="../assets/shop-photo6.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map2"></div>
      <i @click="showInfo('map5')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 西城区 西直门南小街西派国际
        <br />
        3号公寓底商101
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:17610398360">17610398360</a>
    </div>

    <div class="blockTit">远洋国际中心店</div>
    <img src="../assets/shop-photo3.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map3"></div>
      <i @click="showInfo('map6')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 朝阳区 慈云寺远洋国际中心C座
        <br />
        底商107（711便利店）旁
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:15011343283">15011343283</a>
    </div>

    <div class="blockTit">望京店</div>
    <img src="../assets/shop-photo4.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map7"></div>
      <i @click="showInfo('map8')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 朝阳区 望京soho 塔2商业A区
        <br />
        6层2610
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:010-84245231">010-84245231</a>
    </div>

    <div class="blockTit">华熙店</div>
    <img src="../assets/shop-photo7.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map11"></div>
      <i @click="showInfo('map12')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 海淀区 万寿路街道西翠路华熙LIVE
        <br />
        冰上中心B1-108（南侧户外）
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:16710862107">16710862107</a>
    </div>

    <div class="blockTit">泛海国际店</div>
    <img src="../assets/shop-photo8.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map13"></div>
      <i @click="showInfo('map14')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 海淀区 东风乡星火西路19号楼
        <br />
        泛海国际底商二层205
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:16710859827">16710859827</a>
    </div>

    <div class="blockTit">中海大吉巷店</div>
    <img src="../assets/shop-photo9.jpg" class="shop-photo" alt="" />
    <div class="shop-map bmap">
      <div id="map15"></div>
      <i @click="showInfo('map16')"></i>
    </div>
    <div class="blockText address">
      <span>店面地址：</span>
      <span>
        北京市 西城区 骡马市大街
        <br />
        中海大吉巷购物中心B216
      </span>
    </div>
    <div class="blockText address">
      <span>营业时间：</span>
      <span>
        AM 11:00-PM 21:00
        <br />
        (最晚预约时间19:30)
      </span>
    </div>
    <div class="blockText">
      预约电话：<a href="tel:18310572905">18310572905</a>
    </div>

    <mu-dialog :fullscreen="true" :open.sync="dialog">
      <div v-if="mapName == 'map18'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href=" https://m.dianping.com/shopshare/H8BX8lL8C8rBspX3" class="shop-bottom">
          <h2>中关村大融城店</h2>
          <p>
            北京市 海淀区 大融城东区地下2层
            <br />
            X-LG2-11+12
          </p>
        </a>
        <div class="mapContent"><div id="map18"></div></div>
      </div>

      <div v-if="mapName == 'map10'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shopshare/l4rvqNvAxnYpPhUJ" class="shop-bottom">
          <h2>凤凰汇甄选店</h2>
          <p>
            北京市 朝阳区 左家庄街道 凤凰汇购物中心
            <br />
            2层L217
          </p>
        </a>
        <div class="mapContent"><div id="map10"></div></div>
      </div>

      <div v-if="mapName == 'map4'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shop/23721510?from=shoplist&shoplistqueryid=508ca514-82fe-4f84-a52b-90357d3c831b" class="shop-bottom">
          <h2>太古里旗舰店</h2>
          <p>
            北京市 朝阳区 大三里屯太古里南区
            <br />
            B1-SLG21b
          </p>
        </a>
        <div class="mapContent"><div id="map4"></div></div>
      </div>
      <div v-if="mapName == 'map5'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shop/77478330?from=shoplist&shoplistqueryid=c73006ff-db7e-4634-91a6-a14f6c45c4fd" class="shop-bottom">
          <h2>阜成门店</h2>
          <p>
            北京市 西城区 西直门南小街西派国际
            <br />
            3号公寓底商101
          </p>
        </a>
        <div class="mapContent"><div id="map5"></div></div>
      </div>
      <div v-if="mapName == 'map6'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shop/66183368?from=shoplist&shoplistqueryid=c7629103-91fd-4ebf-a2c0-39c8b8755bd4" class="shop-bottom">
          <h2>远洋国际中心店</h2>
          <p>北京市 朝阳区 慈云寺远洋国际中心C座底商107（711便利店）旁</p>
        </a>
        <div class="mapContent"><div id="map6"></div></div>
      </div>
      <div v-if="mapName == 'map8'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shop/G4vWq4X2G1RV8ZIm" class="shop-bottom">
          <h2>望京店</h2>
          <p>北京市 朝阳区 望京soho 塔2商业A区6层2610</p>
        </a>
        <div class="mapContent"><div id="map8"></div></div>
      </div>
      <div v-if="mapName == 'map12'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shopshare/H8JA6GOp4uDJ1DzD" class="shop-bottom">
          <h2>华熙店</h2>
          <p>北京市 海淀区 万寿路街道西翠路华熙LIVE冰上中心B1-108（南侧户外）</p>
        </a>
        <div class="mapContent"><div id="map12"></div></div>
      </div>
      <div v-if="mapName == 'map14'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shopshare/l3qaTd5FaynzbAHu" class="shop-bottom">
          <h2>泛海国际店</h2>
          <p>北京市 朝阳区 东风乡星火西路19号楼泛海国际底商二层205</p>
        </a>
        <div class="mapContent"><div id="map14"></div></div>
      </div>
      <div v-if="mapName == 'map16'">
        <img src="../assets/shop-top.png" alt="" class="shop-top" @click="dialog = false" />
        <a href="https://m.dianping.com/shopshare/laMQ9N05fYV0eV1Q" class="shop-bottom">
          <h2>中海大吉巷店</h2>
          <p>北京市 西城区 骡马市大街中海大吉巷购物中心B216</p>
        </a>
        <div class="mapContent"><div id="map16"></div></div>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
export default {
  name: 'mShop',
  data() {
    return {
      dialog: false,
      mapName: '',
    };
  },
  components: {
    Nav,
  },
  computed: {},
  methods: {
    openDialog() {
      this.dialog = true;
    },
    createMap(name, x, y) {
      var map = new BMap.Map(name);
      var point = new BMap.Point(x, y);
      map.centerAndZoom(point, 15);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker);
      var top_right_navigation = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_SMALL,
      });
      map.addControl(top_right_navigation);
    },
    showInfo(name) {
      this.dialog = true;
      this.mapName = name;
      setTimeout(() => {
        if (name == 'map4') {
          this.createMap('map4', 116.460786, 39.937504);
        } else if (name == 'map5') {
          this.createMap('map5', 116.364762, 39.936733);
        } else if (name == 'map6') {
          this.createMap('map6', 116.497775, 39.918381);
        } else if (name == 'map10') {
          this.createMap('map10', 116.463829, 39.968421);
        } else if (name == 'map12') {
          this.createMap('map12', 116.288985, 39.915306);
        } else if (name == 'map14') {
          this.createMap('map14', 116.507769, 39.943641);
        } else if (name == 'map16') {
          this.createMap('map16', 116.382355, 39.894745);
        } else if (name == 'map18') {
          this.createMap('map18', 116.320679, 39.985970);
        } else {
          this.createMap('map8', 116.486709, 40.002955);
        }
      }, 200);
    },
  },
  mounted() {
    this.createMap('map1', 116.460786, 39.937504);
    this.createMap('map2', 116.364762, 39.936733);
    this.createMap('map3', 116.497775, 39.918381);
    this.createMap('map7', 116.486709, 40.002955);
    this.createMap('map9', 116.463829, 39.968421);
    this.createMap('map11', 116.288985, 39.915306);
    this.createMap('map13', 116.507769, 39.943641);
    this.createMap('map15', 116.382355, 39.894745);
    this.createMap('map17', 116.320679, 39.985970);
  },
};
</script>

<style lang="scss" scoped>
#mShop {
  padding: 350px 32px 140px;
  background: url(../assets/shop-banner.jpg) top/100% no-repeat;

  .address {
    display: flex;
    > span:last-child {
      flex: 1;
    }
  }
}
.blockTit {
  margin: 136px 0 40px;
}
.blockText {
  font-size: 28px;
  line-height: 48px;
  text-align: left;
}
.shop-photo {
  display: block;
  margin-top: 0;
  width: 100%;
}
.shop-map {
  margin-top: 32px;
  height: 420px;
}
.bmap {
  position: relative;
  margin-bottom: 40px;
  > div {
    height: 100%;
  }
  > i {
    position: absolute;
    left: 0;
    top: 0;
    width: 80px;
    height: 80px;
    background: url(../assets/map-icon.png) no-repeat;
    opacity: 0.8;
    z-index: 900;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      opacity: 1;
    }
  }
}
.shop-top {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1400;
  pointer-events: auto;
}
.shop-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 0 30px 40px;
  width: 100%;
  height: 168px;
  background: url(../assets/shop-bottom.png);
  h2 {
    font-size: 30px;
    line-height: 40px;
  }
  p {
    width: 500px;
    font-size: 20px;
    line-height: 36px;
  }
}
.mapContent {
  padding: 110px 0 168px;
  height: 100vh;
  > div {
    height: 100%;
  }
}
</style>
